import { useEffect } from 'react';
import { useSettingsStore } from '../../store/settingsStore';
import { resolveMedia } from '../../lib/api';

const FALLBACK_FAVICON = '/brand-mark-avatar.webp';

function faviconType(href: string) {
  if (/\.webp$/i.test(href)) return 'image/webp';
  if (/\.svg$/i.test(href)) return 'image/svg+xml';
  if (/\.png$/i.test(href)) return 'image/png';
  if (/\.jpe?g$/i.test(href)) return 'image/jpeg';
  if (/\.gif$/i.test(href)) return 'image/gif';
  if (/\.ico$/i.test(href)) return 'image/x-icon';
  return 'image/x-icon';
}

// Keeps the browser-tab favicon in sync with the storefront's phone logo (the
// header avatar). Install icons (manifest + apple-touch-icon) keep their own
// dedicated PNG assets.
export default function FaviconSync() {
  const loaded = useSettingsStore((state) => state.loaded);
  const loadSettings = useSettingsStore((state) => state.loadSettings);
  const phoneLogo = useSettingsStore((state) => state.phoneLogo);

  useEffect(() => {
    if (!loaded) loadSettings();
  }, [loaded, loadSettings]);

  useEffect(() => {
    const href = phoneLogo ? resolveMedia(phoneLogo) : FALLBACK_FAVICON;
    document.querySelectorAll<HTMLLinkElement>('link[rel="icon"]').forEach((link) => {
      link.setAttribute('href', href);
      link.setAttribute('type', faviconType(href));
    });
  }, [phoneLogo]);

  return null;
}